<template>
<div class="upsell-page">
    <!-- Loading overlay -->
    <div v-if="submitting" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <!-- Payment error -->
    <div v-if="errorMessage" class="upsell-error-overlay" @click.self="errorMessage = ''">
        <div class="upsell-error-box">
            <div class="upsell-error-title">Payment Error</div>
            <div class="upsell-error-message">{{ errorMessage }}</div>
            <a href="#" @click.prevent="errorMessage = ''" class="upsell-error-close">Close</a>
        </div>
    </div>

    <!-- Remove-item confirmation modal -->
    <div v-if="itemToRemove" class="upsell-error-overlay" @click.self="cancelRemove">
        <div class="upsell-error-box">
            <div class="upsell-error-title remove-title">Remove this item?</div>
            <div class="upsell-error-message">
                <strong>{{ itemToRemove.name }}</strong> will be removed from your order. You can add it back, or continue without it.
            </div>
            <div class="remove-modal-actions">
                <a href="#" @click.prevent="cancelRemove" class="remove-modal-btn keep">Keep in cart</a>
                <a href="#" @click.prevent="confirmRemoveAndContinue" class="remove-modal-btn remove">Continue without it</a>
            </div>
        </div>
    </div>

    <!-- Logo bar -->
    <section class="section_logo-bar">
        <div class="logonav_wrap">
            <div class="logonav_div">
                <a href="#" class="link-block-73 w-inline-block">
                    <img src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" alt="" class="image-487">
                </a>
            </div>
        </div>
    </section>

    <!-- Main content -->
    <section class="section_checkout-flow upsell-main">
        <div class="flow_wrap">

            <!-- Step 1: Product detail -->
            <div class="upsellflow_div3" v-if="active_el === 1">
                <div class="upsell-flow-header flow">Improve Results. Eliminate Side Effects.</div>
                <div class="upsellflow_subs">Supercharge your results with instant nausea relief for less than an insurance copay.</div>

                <div class="upsell-bundle-div flow">
                    <div class="upsell_bundleimgdiv nausea-img-wrap">
                        <img :src="productImage" loading="lazy" :alt="productName" class="upsell-bundle-img nopad">
                    </div>

                    <div class="bundle_detailsdiv">
                        <div class="upsell_productname_pricediv">
                            <div class="prodname-div">
                                <div class="upsell-procuctname bundle">{{ productName }}</div>
                                <div class="upsell_productsub_div">
                                    <div class="upsell-product-subtext" v-html="productSubtitle"></div>
                                </div>
                            </div>
                        </div>

                        <p class="upsell_paragraph bundle"><strong>Eliminate nausea, the most common GLP side effect</strong>, in one easy-to-take melt-away tablet. Stay on track with your weight loss without the rough days.</p>

                        <div class="benefits_div bundle">
                            <div class="upsell_bullets_div" v-for="(column, ci) in bulletColumns" :key="ci">
                                <div class="div-block-1948" v-for="(bullet, bi) in column" :key="bi">
                                    <img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="upsell_bullet_img">
                                    <div class="upsell-bullet-text no-highlight">{{ bullet }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Single plan card -->
                        <div class="plan-card" :class="{ 'selected': true }">
                            <div class="plan-radio">
                                <span class="plan-radio-dot"></span>
                            </div>
                            <div class="plan-content">
                                <div class="plan-info">
                                    <div class="plan-title">{{ planLabel }}</div>
                                    <div class="plan-subtitle">{{ planSubtitle }}</div>
                                </div>
                                <div class="plan-price-block">
                                    <div class="plan-price">
                                        <sup class="plan-currency">$</sup>{{ priceDollars(planPrice) }}<sup class="plan-cents">{{ priceCents(planPrice) }}</sup>
                                    </div>
                                    <div class="plan-best-value"><strong>Best Value!</strong></div>
                                </div>
                            </div>
                        </div>

                        <div class="form-upsell-button-div">
                            <div class="new-upsell-cart-button-2 var1 flow" :class="{ 'added': isInCart }" @click.prevent="addToCart">
                                <div class="cart-icon-div" v-if="!isInCart">
                                    <div class="code-embed-3-copy cart_btn w-embed">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewBox="0 0 16 16">
                                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="text-block-1714">{{ isInCart ? '✓ ADDED' : 'ADD TO CART' }}</div>
                            </div>
                        </div>

                        <a href="#" class="button-149-copy w-button decline-link" @click.prevent="decline">
                            <strong class="bold-text-43">"I'm not interested in eliminating my side effects"</strong>
                            <span class="text-span-340">-&gt;</span>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Step 2: Order Confirmation -->
            <div class="step4_div" v-if="active_el === 2">
                <div class="inclusions-new">
                    <div class="flow-inclusions-header">Order Confirmation</div>

                    <div class="flow_inclusions-div">
                        <div v-if="cartItems.length === 0" class="empty-cart-message">
                            <p class="inclusions-subs" style="text-align: center; padding: 20px;">
                                Your cart is empty.
                            </p>
                        </div>

                        <div class="cart-row" v-for="item in cartItems" :key="item.plan_id">
                            <div class="cart-row-image-wrap">
                                <img :src="productImage" loading="lazy" alt="" class="cart-row-image">
                            </div>
                            <div class="cart-row-info">
                                <div class="cart-row-title">{{ item.name }} - {{ item.terms }} Months Plan (Recurring)</div>
                                <div class="cart-row-subtitle">{{ planLabel }}</div>
                            </div>
                            <div class="cart-row-right">
                                <div class="cart-row-price">
                                    <sup class="price-currency">$</sup>{{ priceDollars(item.price) }}<sup class="price-cents">{{ priceCents(item.price) }}</sup>
                                </div>
                                <a href="#" class="trash-link" @click.prevent="confirmRemove(item)" aria-label="Remove from cart">
                                    <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="" class="image-713">
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row-divider"></div>

                    <div class="div-block-2248 total">
                        <div class="text-block-1712">Total</div>
                        <div class="div-block-2249">
                            <div class="text-block-1711-copy total">${{ priceDollars(cartTotal) }}<span><sup class="superscript-11 total">{{ priceCents(cartTotal) }}</sup></span></div>
                        </div>
                    </div>

                    <!-- Payment Method -->
                    <div class="payment-method-section">
                        <div class="row-divider"></div>
                        <div class="payment-method-header">
                            <div class="text-block-1712">Payment Method</div>
                        </div>

                        <!-- Card on file (default state) -->
                        <div v-if="!showCardUpdate" class="existing-card-display">
                            <div class="card-info-left">
                                <div class="card-icons">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/visa.webp" class="card-icon">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/mastercard.webp" class="card-icon">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/AmEx.webp" class="card-icon">
                                    <img width="35" loading="lazy" alt="" src="@/assets/images/discover.webp" class="card-icon">
                                </div>
                                <div class="card-on-file-number">{{ cardOnFileDisplay }}</div>
                            </div>
                            <a href="#" class="update-card-link" @click.prevent="openCardUpdate">Update Card</a>
                        </div>

                        <!-- Inline card update form (replaces card-on-file when active) -->
                        <div v-if="showCardUpdate" class="inline-card-form">
                            <div class="form-group">
                                <label>Card number</label>
                                <div id="upsell-card-number-element" class="ns-card-element"></div>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label>Expiration date</label>
                                    <div id="upsell-card-expiry-element" class="ns-card-element"></div>
                                </div>
                                <div class="form-group">
                                    <label>Security code</label>
                                    <div id="upsell-card-cvc-element" class="ns-card-element"></div>
                                </div>
                            </div>
                            <a href="#" class="cancel-update-link" @click.prevent="cancelCardUpdate">Cancel</a>
                        </div>
                    </div>

                    <div class="flow-ctrls-div">
                        <a href="#"
                           class="continue-button step w-button complete-order-btn"
                           :class="{ 'disabled': submitting || cartItems.length === 0 }"
                           @click.prevent="completeOrder">
                            {{ submitting ? 'Processing...' : 'Complete Order' }} <span class="text-span-423">&gt;</span>
                        </a>
                    </div>
                    <div class="flow-ctrls-div">
                        <p class="paragraph-185">
                            By clicking "Complete Order", you authorize RxPros to charge the payment method currently on file for this add-on. You confirm that you have read and agree to the
                            <a href="https://www.rxpros.com/returns-and-refund" target="_blank">Refund Policy</a>,
                            <a href="https://www.rxpros.com/terms-of-use" target="_blank">Terms of Use</a>,
                            <a href="https://www.rxpros.com/privacy-policy" target="_blank">Privacy Policy</a>, and that you are at least 18 years of age.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- TrustPilot footer -->
    <div class="trust-pilot-div upsell-footer">
        <img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
        <div class="flow-rating-div">
            <div class="text-block-1723">Excellent</div>
            <div class="text-block-1724">4.6 out of 5</div>
            <img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/683486885685e2905f4c45af_Trustpilot_Logo_(2022).svg.webp" loading="lazy" alt="Trustpilot" class="image-690">
        </div>
        <div>Trusted by thousands of members</div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadStripe } from '@stripe/stripe-js';
import { fireOrderPurchase } from '@/utils/orderPurchaseTracking';
import { newEventId } from '@/utils/trackingIds';
import { needsBankCheck, recordConfirmedUpsell, runBankChecks, shopperMessage } from '@/utils/bankCheck';

// Authoritative spec from product team (Deepak) — backend IDs and fallback values.
// /api/get-all-plans is used to override price/terms if the backend has a live record.
const TARGET_PRODUCT_ID = '684b25127fc4b1cb8576f02d';
const TARGET_PLAN_ID = '695ea10f212aecbe412f3ab9';
const TARGET_TERMS = 3;
const SPEC_FALLBACK = {
    plan_id: TARGET_PLAN_ID,
    product_id: TARGET_PRODUCT_ID,
    name: 'GLP Anti-Nausea',
    price: 19.97,
    terms: TARGET_TERMS,
};
const PRODUCT_BULLETS = [
    'Instant nausea relief',
    'Easy melt-away tablet',
    'Pairs with your GLP',
    'Stay consistent',
];

export default {
    name: 'UpsellMeds',
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 1,
            cartItems: [],
            submitting: false,
            errorMessage: '',
            plan: null,
            // Inline card update state (matches NewSelf upsell pattern)
            showCardUpdate: false,
            stripe: null,
            elements: null,
            cardNumberElement: null,
            cardExpiryElement: null,
            cardCvcElement: null,
            // Trash confirmation modal — holds the item pending removal
            itemToRemove: null,
            // Card on file (last4) loaded from localStorage after checkout
            cardLast4OnFile: '',
        };
    },
    computed: {
        ...mapGetters(['user', 'shipping']),
        productName() {
            return SPEC_FALLBACK.name;
        },
        productSubtitle() {
            return '4mg Generic Zofran<sup>®</sup> (ondansetron) · 30 Pills';
        },
        productImage() {
            // eslint-disable-next-line global-require
            return require('@/assets/images/checkout-nausea.png');
        },
        bulletColumns() {
            return [PRODUCT_BULLETS.slice(0, 2), PRODUCT_BULLETS.slice(2, 4)];
        },
        effectivePlan() {
            return this.plan || SPEC_FALLBACK;
        },
        planPrice() {
            return this.effectivePlan.price;
        },
        planLabel() {
            const terms = this.effectivePlan.terms;
            if (terms === 3) return '3 Month Supply';
            if (terms === 6) return '6 Month Supply';
            if (terms === 12) return '12 Month Supply';
            if (terms === 1) return 'Monthly Subscription';
            if (terms === 0) return 'One Time Purchase';
            return `${terms} Month Supply`;
        },
        planSubtitle() {
            const terms = this.effectivePlan.terms;
            if (terms >= 3) return 'Commit longer, save more.';
            if (terms === 1) return 'Never miss a refill.';
            return 'One-time purchase.';
        },
        cartTotal() {
            return this.cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        },
        isInCart() {
            return this.cartItems.some(item => item.plan_id === this.effectivePlan.plan_id);
        },
        // Always renders as "•••• •••• •••• XXXX". If last4 is missing or malformed,
        // dots fill the right block so the layout never breaks.
        cardOnFileDisplay() {
            const digits = String(this.cardLast4OnFile || '').replace(/\D/g, '').slice(-4);
            const lastBlock = ('••••' + digits).slice(-4);
            return `•••• •••• •••• ${lastBlock}`;
        },
    },
    watch: {
        active_el() {
            window.scrollTo(0, 0);
        },
    },
    methods: {
        priceDollars(value) {
            return Math.floor(value);
        },
        priceCents(value) {
            const cents = (value % 1).toFixed(2).split('.')[1];
            return cents || '00';
        },
        async loadPlanFromBackend() {
            try {
                const res = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`);
                if (res.data && res.data.status === 'success' && Array.isArray(res.data.plans)) {
                    const productPlans = res.data.plans.filter(p =>
                        (p.product === TARGET_PRODUCT_ID || p.product_id === TARGET_PRODUCT_ID) &&
                        p.terms === TARGET_TERMS &&
                        p.is_active !== false
                    );
                    const match = productPlans.find(p => p.plan_id === TARGET_PLAN_ID || p._id === TARGET_PLAN_ID) || productPlans[0];
                    if (match) {
                        this.plan = {
                            plan_id: match.plan_id || match._id || TARGET_PLAN_ID,
                            product_id: match.product || match.product_id || TARGET_PRODUCT_ID,
                            name: match.name || SPEC_FALLBACK.name,
                            price: typeof match.price === 'number' ? match.price : SPEC_FALLBACK.price,
                            terms: typeof match.terms === 'number' ? match.terms : TARGET_TERMS,
                        };
                    }
                }
            } catch (err) {
                console.error('[UpsellMeds] get-all-plans failed, using spec fallback', err);
            }
        },
        addToCart() {
            if (!this.isInCart) {
                this.cartItems.push({
                    plan_id: this.effectivePlan.plan_id,
                    product_id: this.effectivePlan.product_id || TARGET_PRODUCT_ID,
                    name: this.productName,
                    price: this.effectivePlan.price,
                    retail_price: this.effectivePlan.price,
                    terms: this.effectivePlan.terms,
                    quantity: 1,
                    is_addon: true,
                });
                try {
                    if (window.tracking) {
                        // Step 17 — after the order purchase on 15 and the Fast Track
                        // upsell purchase on 16 (see fastTrackUpsell.js). This is a
                        // second cart, so it needs its own value or revenue reports 0.
                        window.tracking.event('add_to_cart', {
                            funnel_step: 17,
                            form: 'glp1_upsell',
                            product: this.productName,
                            event_value: this.effectivePlan.price,
                            value: this.effectivePlan.price,
                            currency: 'USD',
                            // Without an event_id Meta cannot match this against the
                            // server's copy, so the same add is counted twice.
                            event_id: newEventId(),
                            product_id: this.effectivePlan.product_id || TARGET_PRODUCT_ID,
                            plan_id: this.effectivePlan.plan_id || TARGET_PLAN_ID,
                            product_name: this.productName,
                            quantity: 1,
                        });
                    }
                } catch (e) { console.log(e); }
            }
            setTimeout(() => { this.active_el = 2; }, 400);
        },
        confirmRemove(item) {
            this.itemToRemove = item;
        },
        cancelRemove() {
            this.itemToRemove = null;
        },
        confirmRemoveAndContinue() {
            if (!this.itemToRemove) return;
            this.cartItems = this.cartItems.filter(i => i.plan_id !== this.itemToRemove.plan_id);
            this.itemToRemove = null;
            this.$router.push({ name: 'showStepsToUser' });
        },
        decline() {
            this.$router.push({ name: 'showStepsToUser' });
        },
        async openCardUpdate() {
            this.showCardUpdate = true;
            await this.$nextTick();
            await this.mountStripeElements();
        },
        cancelCardUpdate() {
            this.destroyStripeElements();
            this.showCardUpdate = false;
            this.errorMessage = '';
        },
        async mountStripeElements() {
            try {
                if (!this.stripe) {
                    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
                }
                if (!this.elements) {
                    this.elements = this.stripe.elements();
                }
                const style = {
                    base: {
                        fontSize: '15px',
                        fontWeight: 'normal',
                        color: '#000',
                        '::placeholder': { color: '#9ca3af', fontWeight: 'normal' },
                    },
                };
                this.cardNumberElement = this.elements.create('cardNumber', {
                    style, placeholder: '1234 1234 1234 1234', showIcon: false,
                });
                this.cardNumberElement.mount('#upsell-card-number-element');
                this.cardExpiryElement = this.elements.create('cardExpiry', { style, placeholder: 'MM / YY' });
                this.cardExpiryElement.mount('#upsell-card-expiry-element');
                this.cardCvcElement = this.elements.create('cardCvc', { style, placeholder: 'CVC' });
                this.cardCvcElement.mount('#upsell-card-cvc-element');
            } catch (err) {
                console.error('Stripe init failed', err);
                this.errorMessage = 'Failed to load payment form. Please refresh and try again.';
            }
        },
        destroyStripeElements() {
            try {
                if (this.cardNumberElement) { this.cardNumberElement.destroy(); this.cardNumberElement = null; }
                if (this.cardExpiryElement) { this.cardExpiryElement.destroy(); this.cardExpiryElement = null; }
                if (this.cardCvcElement) { this.cardCvcElement.destroy(); this.cardCvcElement = null; }
            } catch (e) {
                console.warn('Stripe cleanup failed', e);
            }
        },
        async createNewCardToken() {
            const billingDetails = {
                name: `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim(),
                email: this.user?.email || '',
            };
            if (this.shipping) {
                billingDetails.address = {
                    line1: this.shipping.address_line_1 || '',
                    line2: this.shipping.address_line_2 || '',
                    city: this.shipping.city || '',
                    state: this.shipping.state || '',
                    postal_code: this.shipping.zip || '',
                    country: 'US',
                };
            }
            const { paymentMethod, error } = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.cardNumberElement,
                billing_details: billingDetails,
            });
            if (error) {
                throw new Error(error.message || 'Invalid card details. Please check your card information.');
            }
            return {
                id: paymentMethod.id,
                last4: paymentMethod.card?.last4 || '',
                brand: paymentMethod.card?.brand || '',
                exp_month: paymentMethod.card?.exp_month || '',
                exp_year: paymentMethod.card?.exp_year || '',
            };
        },
        ensureCorrelationId() {
            try {
                if (this.correlationId) return this.correlationId;
                if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
                    this.correlationId = crypto.randomUUID();
                    return this.correlationId;
                }
                this.correlationId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    const r = (Math.random() * 16) | 0;
                    const v = c === 'x' ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                });
                return this.correlationId;
            } catch (e) {
                console.log('correlation id generation failed', e);
                this.correlationId = '';
                return '';
            }
        },
        async completeOrder() {
            if (this.cartItems.length === 0 || this.submitting) return;
            this.submitting = true;
            // Fresh idempotency key per upsell attempt. Sent as the X-Correlation-Id header
            // on the charge so the backend's Stripe idempotency key blocks a duplicate of
            // THIS same attempt from creating a second charge.
            this.correlationId = '';
            this.ensureCorrelationId();
            this.errorMessage = '';

            try {
                let cardToken = '';
                let newCardLast4 = '';
                let newCardBrand = '';
                const useExistingCard = !this.showCardUpdate;

                if (this.showCardUpdate) {
                    const pm = await this.createNewCardToken();
                    cardToken = pm.id;
                    newCardLast4 = pm.last4;
                    newCardBrand = pm.brand;
                }

                // Payload shape matches NewSelf's confirmOrder() exactly. Backend looks up
                // cardBrand/cardLast4 from the token (when cardToken present) or from the
                // customer's saved PaymentMethod (when useExistingCard=true). billingAddress
                // and shippingAddress are sent as placeholders — backend uses Stripe's
                // stored customer address.
                const payload = {
                    payment_terms: this.effectivePlan.terms,
                    user_id: this.user?.id,
                    id: this.user?.id,
                    cardToken,
                    cardBrand: '',
                    amount: Math.round(this.cartTotal * 100),
                    discount: 0,
                    medication: '',
                    couponCode: '',
                    drug_mode: '',
                    couponId: null,
                    paymentMethod: 'card',
                    cartItems: this.cartItems,
                    cardDetails: [],
                    planId: '',
                    cardBin: '',
                    cardLast4: '',
                    cartTotal: this.cartTotal,
                    cartTotalNoDiscount: this.cartTotal,
                    offer: '',
                    billingAddress: {},
                    shippingAddress: {
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        state: '',
                        zip: '',
                    },
                    firstName: this.user?.first_name || '',
                    lastName: this.user?.last_name || '',
                    email: this.user?.email || '',
                    mainProductTotal: this.cartTotal,
                    addonTotal: 0,
                    totalOrderAmount: this.cartTotal,
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: '',
                    tracking_session_id: window?.trackingSessionId || 'unknown',
                    useExistingCard,
                    is_upsell: true,
                };
                const response = await this.$axios.post(`${this.baseUrl}/api/upsell-checkout`, payload, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                // A card whose bank wants to confirm: the backend holds the charge until
                // the bank's popup passes, and the re-post records it. Otherwise nothing
                // was charged.
                let bankCheck = null;
                if (needsBankCheck(response.data)) {
                    if (!this.stripe) this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
                    bankCheck = await runBankChecks(this.stripe, [response.data.client_secret]);
                    if (bankCheck.ok) {
                        const post = (body) => this.$axios.post(`${this.baseUrl}/api/upsell-checkout`, body, {
                            headers: { 'X-Correlation-Id': newEventId() }
                        });
                        await recordConfirmedUpsell(post, payload, response.data.payment_intent_id);
                    }
                }

                if ((response.data && response.data.status === 'success') || (bankCheck && bankCheck.ok)) {
                    if (this.showCardUpdate && newCardLast4) {
                        try {
                            localStorage.setItem('rxpros_card_on_file', JSON.stringify({
                                last4: newCardLast4,
                                brand: newCardBrand,
                            }));
                        } catch (e) { console.log(e); }
                    }
                    try {
                        if (window.tracking) {
                            // event_value and currency are required on purchase. Without
                            // them every upsell sale reported as a $0 conversion.
                            window.tracking.event('purchase', {
                                funnel_step: 18,
                                form: 'glp1_upsell',
                                items: this.cartItems.map(i => i.name),
                                event_value: this.cartTotal,
                                total: this.cartTotal,
                                currency: 'USD',
                                // Same reason as the add_to_cart above: a purchase with
                                // no event_id is a sale Meta cannot deduplicate.
                                event_id: newEventId(),
                                product_id: this.effectivePlan.product_id || TARGET_PRODUCT_ID,
                                plan_id: this.effectivePlan.plan_id || TARGET_PLAN_ID,
                                product_name: this.productName,
                                quantity: 1,
                                transaction_id: (bankCheck ? response.data.payment_intent_id : response.data.transaction_id) || '',
                                // Omitted rather than sent empty when the server returns
                                // none, so a blank never reads as a real order id.
                                ...(response.data.order_id ? { order_id: response.data.order_id } : {}),
                            });
                        }
                    } catch (e) { console.log(e); }
                    this.$router.push({ name: 'showStepsToUser' });
                } else {
                    // After a failed bank check the backend's "Your bank needs to confirm"
                    // is stale: this page's own line shows instead.
                    const fallback = 'Payment failed. Please try again.';
                    this.errorMessage = bankCheck
                        ? fallback
                        : shopperMessage(response.data && response.data.message, fallback);
                    this.submitting = false;
                }
            } catch (error) {
                // A backend without the bank check refuses a card whose bank wants to
                // confirm with Stripe's status text: this page's line shows instead.
                // A failed request's own text ("Request failed with status code 502",
                // "Network Error") is not for the patient either. A typed-card mistake
                // from Stripe is, so it keeps its own line.
                this.errorMessage = error && error.isAxiosError
                    ? shopperMessage(error.response?.data?.message, 'Payment failed. Please try again.')
                    : shopperMessage(error?.message, 'Payment failed. Please check your card details and try again.');
                this.submitting = false;
            }
        },
        fireGTM() {
            try {
                const amount = this.$route.query.amount;
                const transid = this.$route.query.trans_id;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'purchase',
                    'ecommerce': {
                        'transaction_id': transid,
                        'value': amount,
                        'currency': 'USD',
                    },
                });
            } catch (error) {
                console.error('Error firing Google pixel:', error);
            }
        },
        // The checkouts and KlarnaReturn now report the order the moment the server
        // confirms payment. This stays as the fallback for a confirmation link opened
        // later, and skips a transaction that was already reported — which is also what
        // stops a refresh of this page from counting the same order twice.
        fireTrackingPurchase() {
            fireOrderPurchase({
                amount: this.$route.query.amount,
                transactionId: this.$route.query.trans_id,
            });
        },
    },
    mounted() {
        this.fireGTM();
        this.fireTrackingPurchase();
        // Non-blocking: page renders with spec fallback, plan price gets overridden if backend returns one
        this.loadPlanFromBackend();
        // Load card-on-file last4 saved by checkoutWeightLoss after the original purchase
        try {
            const stored = JSON.parse(localStorage.getItem('rxpros_card_on_file') || '{}');
            if (stored && stored.last4) this.cardLast4OnFile = stored.last4;
        } catch (e) { console.log(e); }
    },
    beforeDestroy() {
        this.destroyStripeElements();
    },
};
</script>

<style scoped>
/* Payment Error modal — fixed full-viewport overlay, sits above ALL page content */
.upsell-error-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    z-index: 999999;
}
.upsell-error-box {
    background: #fff;
    border-radius: 12px;
    padding: 28px 24px;
    max-width: 420px;
    width: 100%;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}
.upsell-error-title {
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 20px;
    font-weight: 800;
    color: #e74c3c;
    margin-bottom: 12px;
}
.upsell-error-message {
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.4;
}
.upsell-error-close {
    display: inline-block;
    padding: 10px 24px;
    background-color: var(--primary-black, #242424);
    color: #fff;
    border-radius: 8px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
.upsell-error-close:hover {
    background-color: var(--logo-blue, #52b2cf);
}

/* Loading overlay also sits above page content */
.loading-overlay2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999998;
}

/* Sticky-footer: #app is already `display: flex; flex-direction: column; min-height: 100vh`.
   Giving .upsell-page `flex: 1` makes it fill remaining viewport space, which pushes the
   global teal site footer (rendered after router-view in App.vue) down to the bottom of
   the viewport. When content grows tall, this naturally lets the browser scroll. */
.upsell-page {
    flex: 1;
    background: #fff;
}
.section_logo-bar {
    background: #fff;
}
.upsell-footer {
    padding: 16px 16px 24px;
}

.upsell-main {
    padding-bottom: 16px;
}

/* Tighten webflow .flow_wrap padding so card and content aren't pushed down 120px */
.upsell-main .flow_wrap {
    padding-top: 40px;
    padding-bottom: 16px;
    grid-row-gap: 0;
}

.upsell-loading-state {
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ============================================================
   STEP 1 — Product Detail
   ============================================================ */

/* Override webflow button width/alignment so both CTAs are full-width and centered */
.form-upsell-button-div {
    justify-content: center;
    width: 100%;
}
.new-upsell-cart-button-2.var1,
.new-upsell-cart-button-2.var1.flow {
    width: 100%;
    cursor: pointer;
}
.decline-link {
    display: block;
    width: 100%;
    margin-top: 12px;
    text-align: center;
    box-sizing: border-box;
}

/* Product image background tint */
.nausea-img-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    background-color: var(--f6-grey, #f6f6f6);
    border-radius: 13px;
    margin-bottom: 18px;
}
.nausea-img-wrap .upsell-bundle-img {
    max-width: 260px;
    height: auto;
    object-fit: contain;
    transform: scale(1.8);
    transform-origin: center center;
}

/* Plan card — single option, horizontal layout */
.plan-card {
    display: flex;
    align-items: center;
    gap: 14px;
    border: 2px solid #cfe7ff;
    background-color: #eaf4ff;
    border-radius: 12px;
    padding: 14px 16px;
    margin: 16px 0 18px;
    width: 100%;
    box-sizing: border-box;
}
.plan-radio {
    flex: 0 0 auto;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid var(--logo-blue, #52b2cf);
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.plan-radio-dot {
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: var(--logo-blue, #52b2cf);
}
.plan-content {
    flex: 1 1 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    min-width: 0;
}
.plan-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.plan-title {
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 18px;
    font-weight: 800;
    color: #000;
    line-height: 1.2;
}
.plan-subtitle {
    font-size: 13px;
    color: var(--666-grey, #666);
    margin-top: 2px;
    line-height: 1.3;
}
.plan-price-block {
    flex: 0 0 auto;
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.plan-price {
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 28px;
    font-weight: 900;
    color: #000;
    line-height: 1;
    display: inline-flex;
    align-items: flex-start;
}
.plan-currency {
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    margin-right: 1px;
    top: 4px;
    position: relative;
}
.plan-cents {
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    margin-left: 2px;
    top: 4px;
    position: relative;
}
.plan-best-value {
    font-size: 12px;
    color: #000;
    margin-top: 4px;
}

/* ============================================================
   STEP 2 — Order Confirmation
   ============================================================ */

/* Constrain & center the Order Confirmation card */
.step4_div {
    width: 100%;
    max-width: 580px;
    margin: 0 auto;
}

/* Wrapper around all order-confirmation content */
.inclusions-new {
    width: 100%;
}

/* Cart row: image left (teal bg), info middle, price + trash right (stacked) */
.cart-row {
    display: flex;
    align-items: center;
    padding: 14px;
    background-color: #fff;
    border: 1px solid var(--df-grey, #dfdfdf);
    border-radius: 12px;
    margin-bottom: 10px;
    gap: 14px;
}
.cart-row-image-wrap {
    width: 84px;
    height: 84px;
    flex: 0 0 84px;
    border-radius: 10px;
    background-color: rgba(66, 202, 209, 0.22); /* --logo-green at low opacity */
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cart-row-image {
    width: 70%;
    height: 70%;
    object-fit: contain;
    object-position: center;
}
.cart-row-info {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.cart-row-title {
    color: #000;
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 16px;
    font-weight: 800;
    line-height: 1.3;
}
.cart-row-subtitle {
    color: var(--666-grey, #666);
    font-family: var(--inter, Inter, sans-serif);
    font-size: 13px;
    line-height: 1.3;
}
.cart-row-right {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    align-self: stretch;
    gap: 8px;
    min-height: 56px;
}
.cart-row-price {
    color: #000;
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 20px;
    font-weight: 800;
    white-space: nowrap;
    line-height: 1;
    display: inline-flex;
    align-items: flex-start;
}
.cart-row-price .price-currency {
    font-size: 12px;
    font-weight: 800;
    margin-right: 1px;
    top: 4px;
    position: relative;
}
.cart-row-price .price-cents {
    font-size: 12px;
    font-weight: 800;
    margin-left: 1px;
    top: 4px;
    position: relative;
}
.trash-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.55;
    transition: opacity 0.2s ease;
}
.trash-link:hover {
    opacity: 1;
}
.trash-link .image-713 {
    width: 18px;
    height: 18px;
}

@media (max-width: 520px) {
    .cart-row-image-wrap {
        width: 70px;
        height: 70px;
        flex-basis: 70px;
    }
    .cart-row-title {
        font-size: 15px;
    }
}

/* Divider line between sections */
.row-divider {
    background-color: var(--df-grey, #dfdfdf);
    width: 100%;
    height: 1px;
    margin: 14px 0;
}

/* Total row */
.div-block-2248.total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 4px 0 8px;
}
/* Override webflow's red `.text-block-1711-copy` (#ff4c46) — total should be black */
.text-block-1711-copy.total {
    color: #000;
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 22px;
    font-weight: 800;
}

/* Payment Method */
.payment-method-section {
    margin-top: 6px;
}
.payment-method-header {
    margin: 10px 0 6px;
}
.existing-card-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: var(--f3-grey, #f3f3f3);
    border-radius: 10px;
    gap: 12px;
}
.card-info-left {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1 auto;
    min-width: 0;
}
.card-icons {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
}
.card-icon {
    width: 35px;
    height: auto;
}
.card-on-file-number {
    color: var(--primary-black, #242424);
    font-family: var(--inter, Inter, sans-serif);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 2px;
}
.card-on-file-text {
    color: var(--666-grey, #666);
    font-size: 14px;
}
.update-card-link {
    color: var(--logo-blue, #52b2cf);
    font-weight: 700;
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    align-self: center;
}
.update-card-link:hover {
    color: var(--darkbluetext, #30989d);
}

@media (max-width: 520px) {
    .card-icon {
        width: 30px;
    }
    .card-on-file-number {
        font-size: 14px;
    }
}

/* Inline card update form (replaces card-on-file when user clicks "Update Card") */
.inline-card-form {
    padding: 16px;
    background-color: var(--f6-grey, #f6f6f6);
    border-radius: 10px;
    margin-top: 4px;
}
.inline-card-form .form-group {
    margin-bottom: 12px;
}
.inline-card-form .form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 6px;
}
.inline-card-form .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}
.inline-card-form .ns-card-element {
    border: 1px solid #d8dbe0;
    border-radius: 8px;
    padding: 14px;
    font-size: 15px;
    background: #fff;
    min-height: 48px;
}
.cancel-update-link {
    display: inline-block;
    margin-top: 6px;
    color: var(--666-grey, #666);
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
}
.cancel-update-link:hover {
    color: #000;
}

/* Complete Order button — full width, centered, blue (overrides webflow's dark default) */
.flow-ctrls-div {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin-top: 18px;
}
.continue-button.step.complete-order-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 16px 20px;
    font-family: var(--funnel-display, "Funnel Display", sans-serif);
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    background-color: var(--logo-blue, #52b2cf);
    border-radius: 32px;
    box-sizing: border-box;
    text-decoration: none;
    transition: background-color 0.2s ease;
}
.continue-button.step.complete-order-btn:hover {
    background-color: var(--darkbluetext, #30989d);
    color: #fff;
}
.continue-button.step.complete-order-btn .text-span-423 {
    margin-left: 6px;
}
.complete-order-btn.disabled {
    opacity: 0.5;
    pointer-events: none;
}

/* Remove-item modal — reuses .upsell-error-overlay/.upsell-error-box framework */
.upsell-error-title.remove-title {
    color: var(--primary-black, #242424);
}
.remove-modal-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}
.remove-modal-btn {
    display: inline-block;
    padding: 10px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
    box-sizing: border-box;
    min-width: 140px;
    text-align: center;
}
.remove-modal-btn.keep {
    background-color: var(--logo-blue, #52b2cf);
    color: #fff;
}
.remove-modal-btn.keep:hover {
    background-color: var(--darkbluetext, #30989d);
}
.remove-modal-btn.remove {
    background-color: #fff;
    color: var(--666-grey, #666);
    border: 1px solid var(--df-grey, #dfdfdf);
}
.remove-modal-btn.remove:hover {
    background-color: var(--f6-grey, #f6f6f6);
    color: var(--primary-black, #242424);
}

/* Fine print legal copy — small, justified, gray. Webflow's .paragraph-185 is 18px center-aligned which is wrong for legal copy */
.paragraph-185 {
    color: var(--666-grey, #666);
    font-family: var(--inter, Inter, sans-serif);
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
    margin: 14px 0 0;
}
.paragraph-185 a {
    color: var(--logo-blue, #52b2cf);
    text-decoration: underline;
}

/* Empty cart fallback */
.empty-cart-message {
    padding: 30px 20px;
    text-align: center;
    background-color: var(--f9-grey, #f9f9f9);
    border-radius: 8px;
    margin: 12px 0;
}
</style>
